import { type FormKitNode } from '@formkit/core'

const isCheckboxAndRadioMultiple = (node: FormKitNode) =>
  (node.props.type === 'checkbox' || node.props.type === 'radio') &&
  node.props.options

export default function addAsteriskPlugin(node: FormKitNode) {
  node.on('created', () => {
    if (node.props.definition) {
      const schemaFn = node.props.definition.schema
      node.props.definition.schema = (sectionsSchema = {}) => {
        const isRequired = node.props.parsedRules.some(
          (rule: any) => rule.name === 'required'
        )

        if (isRequired) {
          if (isCheckboxAndRadioMultiple(node)) {
            sectionsSchema.legend = {
              //@ts-ignore
              ...sectionsSchema.legend,
              children: [
                '$label',
                {
                  $el: 'span',
                  attrs: {
                    'aria-hidden': true,
                  },
                  children: ['*'],
                },
              ],
            }
          } else {
            sectionsSchema.label = {
              //@ts-ignore
              ...sectionsSchema.label,
              children: [
                '$label',
                {
                  $el: 'span',
                  attrs: {
                    'aria-hidden': true,
                  },
                  children: ['*'],
                },
              ],
            }
          }
        }

        //@ts-ignore
        return schemaFn(sectionsSchema)
      }
    }
  })
}
